module.exports = __webpack_public_path__ + "img/tb.4383829e.png";